/**
 * Auto-opens the welcome popup (10% off email signup) a few seconds after
 * the page loads, once per visitor. Suppressed entirely once they've either
 * subscribed or dismissed it (until the configured "remind again" period
 * has passed), tracked via localStorage since this has no server-side
 * per-visitor state.
 */
const STORAGE_KEY = 'human-apparel:welcome-popup';

function readState() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

function writeState(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {
    // Ignore storage errors (private browsing, quota, etc.) - the popup
    // will just show again next visit, which is an acceptable fallback.
  }
}

function shouldShow(el) {
  const state = readState();
  if (!state) return true;
  if (state.subscribed) return false;

  const reminderDays = Number(el.dataset.reminderDays) || 7;
  const reminderMs = reminderDays * 24 * 60 * 60 * 1000;
  return Date.now() - state.dismissedAt > reminderMs;
}

document.querySelectorAll('.welcome-popup-component').forEach((el) => {
  if (el.dataset.justSubscribed === 'true') {
    writeState({ subscribed: true });
    el.showDialog();
    return;
  }

  if (!shouldShow(el)) return;

  const delaySeconds = Number(el.dataset.delaySeconds) || 0;

  window.setTimeout(() => {
    el.showDialog();
  }, delaySeconds * 1000);

  el.addEventListener('dialog:close', () => {
    writeState({ dismissedAt: Date.now() });
  });
});
